import type {
	AiManagedObjectConfig,
	AiManagedObjectConfigCreateInput,
} from '../entry-points/types';
import {
	type AiManagedObjectUpdateIntervalPreset,
	getDesiredUpdateFrequencyForInterval,
} from './update-interval';

export const toAiManagedObjectConfigInputWithUpdateInterval = (
	config: AiManagedObjectConfig,
	updateInterval?: AiManagedObjectUpdateIntervalPreset,
): AiManagedObjectConfigCreateInput => ({
	automation: {
		desiredUpdateFrequency: getDesiredUpdateFrequencyForInterval(updateInterval),
		updateOnSourceEvents: config.automation.updateOnSourceEvents,
	},
	goal: config.goal ?? undefined,
	goalOperations: config.goalOperations ?? undefined,
	prompt: config.prompt ?? null,
	sources:
		config.sources?.map((source) => ({
			app: source.app,
			...(source.url ? { url: source.url } : {}),
		})) ?? undefined,
});
